import React, { useEffect, useState } from "react";
import Aside from "../../components/aside/aside.component";
import Footer from "../../components/footer/footer.component";
import Header from "../../components/header/header.component";
import FormModal from "./form.modal";
import { LoanCreditsService } from "../../services/loan-credits";
import { UtilsService } from "../../services/utils";

let originalList: any[] = [];

function AccountsPage() {
  const [showModal, setShowModal] = useState({
    data: null,
    show: false,
  });
  const [list, setList] = useState<any[]>([]);

  const getList = async () => {
    const data = await LoanCreditsService.list();
    originalList = data;
    setList(data);
  };

  const handleModal = (refresh?: boolean) => {
    if (refresh) {
      getList();
    }
    setShowModal({ data: null, show: false });
  };

  useEffect(() => {
    getList();
  }, []);

  const filter = (term: string) => {
    if(!term ) { 
      setList(originalList);
    }

    const regex = new RegExp(term, 'i'); 
    const $data = originalList.filter((row: any) => {
      return regex.test(`${row._id}`) ||
             regex.test(`${row.name}`)
    })
    setList($data);
  }

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <Aside />
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header />
            <div
              className="content fs-6 d-flex flex-column flex-column-fluid"
              id="kt_content"
            >
              <div className="toolbar" id="kt_toolbar">
                <div className="container-fluid d-flex flex-stack flex-wrap flex-sm-nowrap">
                  <div className="d-flex flex-column align-items-start justify-content-center flex-wrap me-2">
                    <h1 className="text-gray-900 fw-bold my-1 fs-2">
                      Cuentas de préstamos y créditos
                      <small className="text-muted fs-6 fw-normal ms-1" />
                    </h1>
                    <ul className="breadcrumb fw-semibold fs-base my-1">
                      <li className="breadcrumb-item text-muted">
                        Configuración
                      </li>
                      <li className="breadcrumb-item text-gray-900">
                        Cuentas de préstamos y créditos
                      </li>
                    </ul>
                  </div>
                  <div className="d-flex align-items-center flex-nowrap text-nowrap py-1">
                    <button
                      className="btn btn-primary"
                      onClick={() => setShowModal({ data: null, show: true })}
                    >
                      <i className="ki-duotone ki-plus"></i> Agregar cuenta
                    </button>
                  </div>
                </div>
              </div>

              <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
                <div className="container-xxl">
                  <div className="card">
                    <div className="card-header border-0 pt-6">
                      <div className="card-title">
                        <div className="d-flex align-items-center position-relative my-1">
                          <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
                            <span className="path1" />
                            <span className="path2" />
                          </i>
                          <input
                            className="form-control form-control-solid w-250px ps-13"
                            placeholder="Buscar préstamos y créditos"
                            type="text"
                            onChange={({ target: { value } }) => filter(value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card-body py-4">
                      <div
                        className="dt-container dt-bootstrap5 dt-empty-footer"
                        id="kt_table_users_wrapper"
                      >
                        <div className="table-responsive" id="">
                          <table
                            className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
                            id="kt_table_users"
                          >
                            <thead>
                              <tr
                                className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
                                role="row"
                              >
                                <th
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    ID
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Role: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Nombre
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Last login: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Estatus
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Joined Date: Activate to sort"
                                  className="min-w-125px "
                                  colSpan={1}
                                  rowSpan={1}
                                  tabIndex={0}
                                >
                                  <span
                                    className=""
                                    
                                  >
                                    Fecha de creación
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                                <th
                                  aria-label="Actions"
                                  className="text-end min-w-100px dt-orderable-none"
                                  colSpan={1}
                                  rowSpan={1}
                                >
                                  <span className="">
                                    Acciones
                                  </span>
                                  <span className="dt-column-order" />
                                </th>
                              </tr>
                            </thead>
                            <tbody className="text-gray-600 fw-semibold">
                              {list.map((row) => (
                                <tr key={row._id}>
                                  <td>{row._id}</td>
                                  <td>
                                    <div className="d-flex flex-column">
                                      <p className="text-gray-800 m-0">
                                        {row.name}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    {row.status ? (
                                      <div className="badge badge-success fw-bold">
                                        Activo
                                      </div>
                                    ) : (
                                      <div className="badge badge-danger fw-bold">
                                        Inactivo
                                      </div>
                                    )}
                                  </td>
                                  <td>
                                    {UtilsService.dateFormat(row.created_at)}
                                  </td>
                                  <td className="text-end">
                                    <button
                                      className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                                      onClick={() =>
                                        setShowModal({ data: row, show: true })
                                      }
                                    >
                                      Editar
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot />
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

			<FormModal
        show={showModal.show}
        data={showModal.data}
        setShow={handleModal}
      />
    </>
  );
}

export default AccountsPage;
